import React from 'react';

const DiaryNoteForm = ({
  title,
  note,
  onNoteChange,
  onSave,
  saveLabel = 'Uložit do deníku',
  required = false,
  inputDisabled = false,
  buttonDisabled = false,
  statusMessage = '',
  statusTone = 'success',
  children
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden mb-6">
      {/* Neutral gradient header */}
      <div className="bg-gradient-to-r from-gray-700 to-gray-600 px-5 py-4">
        <div className="flex items-center gap-3">
          <div>
            <h3 className="text-lg font-bold text-white">{title}</h3>
            {required && (
              <>
                <p className="text-gray-300 text-sm font-medium">
                  Tento dotazník je poze pro zpětnou vazbu z testování. V ostré verzi nebude.
                </p>
                <p className="text-gray-300 text-sm font-medium mt-1">
                  Chápeme že vyplňovat dotazník může být nuda, ale moc nám to pomůže při vývoji aplikace.
                  <br />Děkujeme ❤️
                </p>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="p-5">
        {/* Diary note textarea */}
        <div className="mb-2">
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Vaše poznámka
          </label>
          <textarea
            className="w-full border-2 border-gray-200 rounded-xl p-4 text-gray-700 leading-relaxed
                       focus:border-gray-400 focus:ring-2 focus:ring-gray-100 focus:outline-none
                       placeholder:text-gray-400 transition-all resize-none"
            rows={4}
            value={note}
            onChange={(event) => onNoteChange(event.target.value)}
            placeholder="Zapište si poznámku..."
            disabled={inputDisabled}
          />
        </div>

        {/* Divider + questionnaire children */}
        {children && (
          <>
            <div className="relative my-6">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-200"></div>
              </div>
              <div className="relative flex justify-center">
                <span className="bg-white px-3 text-sm font-medium text-gray-400">
                  Dotazník
                </span>
              </div>
            </div>
            {children}
          </>
        )}

        {/* Save button + status */}
        <div className="flex items-center justify-between mt-6">
          <div>
            {statusMessage && (
              <div className={`flex items-center gap-2 text-sm font-medium ${
                statusTone === 'error' ? 'text-red-600' : 'text-green-600'
              }`}>
                {statusTone === 'error' ? (
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                ) : (
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                )}
                {statusMessage}
              </div>
            )}
          </div>
          <button
            className={`px-6 py-2.5 rounded-xl font-semibold transition-all text-sm ${
              buttonDisabled
                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                : 'bg-gray-700 hover:bg-gray-800 text-white shadow-md hover:shadow-lg active:scale-95'
            }`}
            onClick={onSave}
            disabled={buttonDisabled}
          >
            {saveLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiaryNoteForm;
